import "../../assets/styles/cards.css";
import animalno01 from "../../assets/images/animal/animalhosp.jpg";
import animalno02 from "../../assets/images/animal/animalhosp2.jpg";
import animalno03 from "../../assets/images/animal/dogword.jpg";
import noImage from "../../assets/images/animal/noimage.jpg";
import { FiSearch } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegStar } from "react-icons/fa";
const cards = [
  {
    id: 1,
    image: animalno03,
    title: "Appointments Available Now Melbourne SPACE COAST",
    time: "10 mins ago",
    location: "Costa Mesa",
    para: "Walk-ins OK",
  },
  {
    id: 2,
    image: animalno02,
    title: "Trusted Establishment with the best staff. You pet will thank you",
    time: "12 mins ago",
    location: "Santa Ana",
    para: "Appnt $65",
  },
  {
    id: 3,
    image: animalno01,
    title: "Appointments Available Now Melbourne SPACE COAST",
    time: "10 mins ago",
    location: "Costa Mesa",
  },
  {
    id: 4,
    image: noImage,
    title: "Trusted Establishment with the best staff. You pet will thank you",
    time: "12 mins ago",
    location: "Santa Ana",
  },
];
function Cards() {
  return (
    <div className="listings">
      <div className="input-wrapper">
        <FiSearch className="search-icon" />
        <input className="page-input" placeholder="search general practices" />
      </div>
      <div className="jobs-1">
        <main className="listings">
          <div className="card-grid-1">
            {cards.map((animal, index) => (
              <div className="main-card" key={index}>
               {animal.para && <p className="p-absolute">{animal.para}</p>} 
                <img
                  src={animal.image}
                  className="cus-card-img-top"
                  alt={`Image number ${index + 1}`}
                />
                <div className="card-body-padding">
                  <p>{animal.title}</p>
                  <div>
                    <div className="card-icon">
                      <p>
                        <span>
                          <FaRegStar />
                        </span>
                       {animal.time} * {animal.location}
                      </p>
                      <div>
                        <RiDeleteBin6Line />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Cards;
